import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap4-modal';
import { connect } from 'react-redux';
import { setNotificationExceptions } from '../../actions/uiPreferences';

const initialNewsletterModalData = {
  email: '',
  digestType: 'weekly',
};

const TYPE_USER_BANNED = 'user_banned';
const TYPE_COMMENT_DELETED = 'comment_deleted';
const TYPE_COMMENT_THREAD_DELETED = 'comment_thread_deleted';
const TYPE_USER_TAGGED = 'user_tagged';
const TYPE_USER_REACTED = 'user_reacted';
const TYPE_USER_REPLIED = 'user_replied';
const TYPE_AUTO_HELD_COMMENT_ADDED = 'auto_held_comment_added';
const TYPE_FOLLOW_ALERTS = 'follow';

const NotificationTypes = [
  { label: 'Bans', key: TYPE_USER_BANNED },
  { label: 'Thread Deletions', key: TYPE_COMMENT_THREAD_DELETED },
  { label: 'Comment Deletions', key: TYPE_COMMENT_DELETED },
  { label: 'Tags', key: TYPE_USER_TAGGED },
  { label: 'Reactions', key: TYPE_USER_REACTED },
  { label: 'Replies', key: TYPE_USER_REPLIED },
  { label: 'Approvals', key: TYPE_AUTO_HELD_COMMENT_ADDED },
  { label: 'Follow Alerts', key: TYPE_FOLLOW_ALERTS },
];
const InitialNotificationDataStructure = {
  user_banned: true,
  comment_deleted: true,
  comment_thread_deleted: true,
  user_tagged: true,
  user_reacted: true,
  user_replied: true,
  auto_held_comment_added: true,
  follow: true,
};

const NotificationSettingsModal = ({
  id,
  isOpen,
  onClose,
  notificationExceptions,
  updateExceptions,
}) => {
  const focusInputRef = useRef(null);
  const [formState, setFormState] = useState(
    InitialNotificationDataStructure,
  );

  useEffect(() => {
    const updatedState = {};
    notificationExceptions.forEach((notificationType) => updatedState[notificationType] = false);
    setFormState(prevFormData => ({
      ...prevFormData,
      ...updatedState,
    }));
  }, [JSON.stringify(notificationExceptions)]);

  useEffect(() => {
    if (isOpen && focusInputRef.current) {
      setTimeout(() => focusInputRef?.current?.focus(), 0);
    }
  }, [isOpen]);

  const onClosing = () => {
    const updatedState = {};
    notificationExceptions.forEach((notificationType) => updatedState[notificationType] = false);
    setFormState({
      ...InitialNotificationDataStructure,
      ...updatedState,
    });
    onClose();
  };

  const handleInputChange = (event) => {
    const { name, checked } = event.target;
    setFormState(prevFormData => ({
      ...prevFormData,
      [name]: checked,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const notificationSettings = { ...formState };
    const exceptions = Object.keys(notificationSettings).filter((notificationType) => {
      return notificationSettings[notificationType] === false;
    });
    updateExceptions(exceptions);
    setFormState(InitialNotificationDataStructure);
    onClose();
  };

  return (
    <Modal visible={isOpen} onClickBackdrop={onClosing}>
      <div className="modal-header text-dark">
        <h5 className="modal-title">Notification Settings</h5>
      </div>
      <div className="modal-body text-dark">
        <form onSubmit={handleSubmit} className="container">
          <div className="row mb-3 font-weight-bold">
            Select the notification types you wish to receive:
          </div>
          {NotificationTypes.map((typeInfo) => (
            <div className="form-group row" key={typeInfo.key}>
              <div className="custom-control custom-switch cursor-pointer">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={`${id}-${typeInfo.key}`}
                  name={typeInfo.key}
                  checked={formState[typeInfo.key]}
                  onChange={handleInputChange}
                />
                <label className="custom-control-label" htmlFor={`${id}-${typeInfo.key}`} style={{ cursor: 'pointer' }}>{typeInfo.label}</label>
              </div>
            </div>
          ))}
        </form>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onClosing}>
          Close
        </button>
        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
          Save
        </button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    notificationExceptions: state.uiPreferences.notificationExceptions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateExceptions: exceptions => dispatch(setNotificationExceptions(exceptions)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSettingsModal);
